import styled, { css } from "styled-components";
import { BTTO_PROFILE_COLORS } from "@pages/profile-v2/betto/shared/elements";

const isBetto = window.TENANT === "betto";

const DropdownWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 5px;
	transform: rotate(0deg);
	height: ${isBetto ? "44px" : "40px"};
	padding: 5px 10px 5px 15px;
	align-self: stretch;
	max-width: 100px;
	min-width: 100px;
	justify-content: space-between;
	background: ${isBetto ? BTTO_PROFILE_COLORS.surfaceRaised : "rgba(0, 0, 0, 0.9)"};
	border: ${isBetto ? `1px solid ${BTTO_PROFILE_COLORS.border}` : "none"};
	border-radius: ${isBetto ? "8px" : "25px"};
	cursor: pointer;
	transition:
		background 0.2s ease,
		border-color 0.2s ease;

	@media (min-width: 375px) {
		max-width: 150px;
		min-width: 150px;
	}

	@media (min-width: 425px) {
		max-width: 180px;
		min-width: 180px;
	}

	svg {
		width: 20px;
		height: 20px;
		flex-shrink: 0;

		path {
			fill: ${isBetto ? BTTO_PROFILE_COLORS.textMuted : "currentColor"};
		}
	}

	&:hover {
		${isBetto &&
		css`
			border-color: ${BTTO_PROFILE_COLORS.borderActive};
			background: ${BTTO_PROFILE_COLORS.surfaceHover};
		`}
	}

	${({ rotate }) =>
		rotate &&
		css`
			svg {
				&:last-of-type {
					transform: rotate(180deg);
					animation: rotate 0.1s;
				}
			}
		`}

	${({ isDropdownOpen }) =>
		isDropdownOpen &&
		css`
			display: flex;
			height: ${isBetto ? "44px" : "40px"};
			padding: 5px 10px 5px 15px;
			align-items: center;
			gap: 5px;
			align-self: stretch;
			${isBetto
				? css`
						border-radius: 8px 8px 0 0;
						background: ${BTTO_PROFILE_COLORS.surfaceRaised};
						border-color: ${BTTO_PROFILE_COLORS.border};
						border-bottom-color: transparent;
					`
				: css`
						border-radius: 20px 20px 0 0;
						background: linear-gradient(0deg, #191726 0%, #050512 100%);
						box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
						backdrop-filter: blur(15px);
					`}
		`}
`;

const HeaderText = styled.div`
	display: block;
	color: ${isBetto ? BTTO_PROFILE_COLORS.text : "var(--secondary-text-color)"};
	font-size: 12px;
	font-weight: ${isBetto ? "500" : "400"};
	line-height: 20px;
	letter-spacing: 0.3px;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	max-width: 45px;
	min-width: 45px;

	@media (min-width: 375px) {
		max-width: 100px;
		min-width: 100px;
	}

	@media (min-width: 425px) {
		max-width: 130px;
		min-width: 130px;
	}
`;

const StyledMenu = styled.div`
	list-style: none;
	display: flex;
	flex-direction: column;
	color: ${isBetto ? BTTO_PROFILE_COLORS.text : "var(--main-secondary-text-color)"};
	max-width: 100px;
	min-width: 100px;
	opacity: 1;
	position: absolute;
	z-index: 999;
	border-radius: ${isBetto ? "0 0 8px 8px" : "0 0 20px 20px"};
	background: ${isBetto ? BTTO_PROFILE_COLORS.surface : "var(--modal-bg)"};
	border: ${isBetto ? `1px solid ${BTTO_PROFILE_COLORS.border}` : "none"};
	border-top: ${isBetto ? "none" : undefined};
	box-shadow: ${isBetto
		? "0 8px 24px rgba(0, 0, 0, 0.24)"
		: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)"};
	backdrop-filter: ${isBetto ? "none" : "blur(15px)"};
	font-size: 12px;
	font-weight: 400;
	line-height: 20px;
	letter-spacing: 0.3px;
	overflow: hidden;

	@media (min-width: 375px) {
		max-width: 150px;
		min-width: 150px;
	}

	@media (min-width: 425px) {
		max-width: 180px;
		min-width: 180px;
	}
`;

const StyledMenuItem = styled.div`
	display: flex;
	height: 40px;
	padding: 5px 10px 5px 15px;
	align-items: center;
	gap: 5px;
	align-self: stretch;
	cursor: pointer;
	color: ${isBetto ? BTTO_PROFILE_COLORS.textMuted : "inherit"};
	transition:
		background 0.2s ease,
		color 0.2s ease;

	&:hover {
		${isBetto &&
		css`
			background: ${BTTO_PROFILE_COLORS.surfaceHover};
			color: ${BTTO_PROFILE_COLORS.text};
		`}
	}

	svg {
		width: 20px;
		height: 20px;

		path {
			fill: ${isBetto ? BTTO_PROFILE_COLORS.textMuted : "var(--main-secondary-text-color)"};
		}
	}
`;

export { DropdownWrapper, HeaderText, StyledMenu, StyledMenuItem };
